<template>
  <ValidationObserver ref="observer">
    <form ref="add_dp_amount_form" @submit.prevent="addSparePartTransfer">
      <md-card>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-small-size-100">
              <validation-provider rules="required" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Transfer from</label>
                  <md-select v-model="spare_part_transfer_warehouse_from_id" required>
                    <md-option v-for="option in options_warehouse_list" :key="option.value" :value="option.id">
                      {{ option.warehouse_name }}
                    </md-option>
                  </md-select>
                  <validation-error
                    :errors="apiValidationErrors.spare_part_transfer_warehouse_from_id"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>

            <div class="md-layout-item md-small-size-100">
              <validation-provider rules="required" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Transfer to Eshed</label>
                  <md-select v-model="spare_part_transfer_warehouse_to_id" required>
                    <md-option v-for="option in options_warehouse_list" :key="option.value" :value="option.id">
                      {{ option.warehouse_name }}
                    </md-option>
                  </md-select>
                  <validation-error
                    :errors="apiValidationErrors.spare_part_transfer_warehouse_to_id"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-100 md-small-size-100" style="margin-bottom:10px;">
              <md-field >
                <label class="label" >Remark</label>
                <md-textarea v-model="spare_part_transfer_remark" md-counter="150" maxlength="150" md-autogrow></md-textarea>
              </md-field>
            </div>
          </div>
          

          <div class="md-layout">
            <autoextra :collection="item" v-slot="{item,last,index}" >
          <div class="columns" :class="{last: last}">
              <div class="header" style="font-weight:bold; text-align:center; margin-bottom:20px; font-size:20px;">
                <label  class="label">{{last ? 'New ' : ''}}Item {{!last ? index + 1 : ''}}</label>
              </div>
              <div  class="md-layout">
                  <input v-model="item.spare_part_transfer_item_master_id" type="hidden"/>

                  <div class="md-layout-item md-size-20 md-small-size-100">
                    <validation-provider  v-slot="{ errors }">
                    <md-field class="md-invalid">
                      <label class="label" >Spare part Name</label>
                        <md-input  v-model="item.spare_part_name" disabled/>
                          <md-button style="background-color:green;" :disabled="!spare_part_transfer_warehouse_from_id" class="md-icon-button md-round md-info md-dense" v-on:click="modalOpenListSparePart(index)" >
                          <md-icon >search</md-icon>
                        </md-button>
                        <validation-error :errors="apiValidationErrors.spare_part_name" />
                        
                        <span class="md-error">{{ errors[0] }}</span> 
                      </md-field>
                    </validation-provider>
                  </div>
                  
                  <div class="md-layout-item md-size-20 md-small-size-50" style="margin-left:40px;">
                    <md-field >
                      <label class="label" >Stock</label>
                      <md-input  v-model="item.stock"  :readonly="true"/>
                        
                    </md-field>
                  </div>
                  
                  <div class="md-layout-item md-size-20 md-small-size-100">
                    <md-field >
                      <label class="label" >Total Transferred</label>
                      <md-input  v-model="item.spare_part_transfer_item_qty" :disabled="item.spare_part_name==null" v-on:keypress="NumbersOnly"/>
                        
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-20 md-small-size-50">
                    <md-field >
                      <label class="label" >Remark</label>
                      <md-input  v-model="item.spare_part_transfer_item_remark" :disabled="item.spare_part_name==null"/>
                        
                    </md-field>
                  </div>
                        
                  <md-card-actions style="border:none;">
                    <md-button class="md-button-icon md-danger md-dense" @click="deleteColumn(index)">
                      delete
                    </md-button>
                  </md-card-actions>
                      
                </div> 
              </div>
            </autoextra>

          </div>


            <!-- <div class="md-layout-item md-small-size-100">
              <validation-provider rules="required" v-slot="{ errors }">
                <md-autocomplete
                  v-model="selectedCountry"
                  :md-options="countries"
                >
                  <label>Spare Part</label>
                  <validation-error
                    :errors="apiValidationErrors.dp_amount_type"
                  />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-autocomplete>
              </validation-provider>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item md-size-50 md-small-size-100">
              <validation-provider rules="dpamountamount" v-slot="{ errors }">
                <md-field class="md-invalid">
                  <label>Qty</label>
                  <md-input
                    type="text"
                    v-on:keypress="NumbersOnly"
                    v-model="dp_amount"
                    required
                  />
                  <validation-error :errors="apiValidationErrors.dp_amount" />
                  <span class="md-error">{{ errors[0] }}</span>
                </md-field>
              </validation-provider>
            </div>
          </div> -->
        </md-card-content>
        <modal ref="modalSparePart" class="coba">
          <!-- <template v-slot:header>
            <h3>List Item</h3>
          </template> -->
            
          <template v-slot:body>
            <list-spare-part :data_id="$refs.modalSparePart.data"/>
          </template>
        </modal>

        <md-card-actions>
          <md-button class="md-info md-dense" @click="addConfirmation" v-if="item.length!=0">
            Submit
          </md-button>
        </md-card-actions>
      </md-card>
    </form>
  </ValidationObserver>
</template>

<script>
// import ListVehicleType from "@/pages/Dashboard/Fms/DpAmount/Modal/ListVehicleType.vue";
import { Modal } from "@/components";
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import { extend, validate, localize, ValidationObserver } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import  Autoextra  from 'vue-autoextra';
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import Swal from "sweetalert2";
import ListSparePart from "@/pages/Dashboard/Workshop/SparePartTransfer/Modal/ListSparePart.vue";

Vue.use(VueSweetalert2);

// mengirim pesan error ketika required field tidak diisi

extend("required", {
  ...required,
  message: "Field is required",
});
export default {
  name: "add-dp-amount",

  props: {
    data: Object,
  },

  components: {
    ValidationError,
    ValidationObserver,
    Modal,
    Autoextra,
    "list-spare-part": ListSparePart,
  },

  mixins: [formMixin],

  data: () => ({
    item: [],
    spare_part_transfer_warehouse_to_id: null,
    spare_part_transfer_warehouse_from_id:null,
    spare_part_transfer_remark: null,
    options_warehouse_list: null
  }),

  created() {
    this.getWarehouse();
  },

  methods: {

    async getWarehouse(){
      await this.$store.dispatch("workshop_warehouse/list")
      this.options_warehouse_list = await this.$store.getters["workshop_warehouse/list"]
    },

    modalOpenListSparePart(index){
      // this.$refs.modalSparePart.openModal({dealer_id: this.procurement_order_dealer_id,index: index})
      this.$refs.modalSparePart.openModal({warehouse_id: this.spare_part_transfer_warehouse_from_id,index: index})
    },

    modalCloseListSparePart(data, index){
        // console.log(data)
        // console.log(data.spare_part_price_lower_price[0].id)
        // console.log(data.id)

        if(data.id){

          this.$set(this.item, index, {
            spare_part_transfer_item_master_id : data.id,
            spare_part_name : data.spare_part_master_name,
            stock: data.spare_part_master_stock,
            spare_part_transfer_item_qty: data.spare_part_transfer_item_qty,
            spare_part_transfer_item_remark: data.spare_part_transfer_item_remark
            
          });


            // pko_driver_kip_no_text : data.driver_no
            this.$refs.modalSparePart.closeModal()
            console.log(this.item)
        }
        

      },

    NumbersOnly(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    // validasi menggunakan sweetalert  sebelum menambah data
    async addConfirmation() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return;
      }
      Swal.fire({
        title: "Are you sure?",
        text: "The data will be saved!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Save it!",
        cancelButtonText: "No, cancel!",
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.addSparePartTransfer();
        }
      });
    },

    deleteColumn(index){
        if (index > -1) {
           this.item.splice(index, 1)
        }
        
      },


    // fungsi add data
    async addSparePartTransfer() {
      const data = {
        type: "workshop_spare_part_transfers",
        // client_no: this.client_no,
        spare_part_transfer_warehouse_from_id: this.spare_part_transfer_warehouse_from_id,
        spare_part_transfer_warehouse_to_id: this.spare_part_transfer_warehouse_to_id,
        spare_part_item: this.item,
        spare_part_transfer_remark: this.spare_part_transfer_remark
        
      };

      try {
        await this.$store.dispatch("workshop_spare_part_transfer/add", data);
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
        this.$parent.$parent.modalCloseAdd();
      } catch (e) {
        // await this.$store.dispatch(
        //   "alerts/error",
        //   "Oops, something went wrong"
        // );
        console.log(e);
        this.setApiValidation(e.response.data.errors);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.coba {
  width: 800px !important;
  margin: 50px auto !important;
  top: auto !important;
  bottom: auto !important;
  z-index: 9999 !important;

  @media screen and (max-width: 992px) {
    width: 90% !important;
    z-index: 9999 !important;
  }
}
</style>
